import { payoutConstants } from "../constants/payoutConstants";

const initialState = {
  sending: false,
  payoutStatus: {},
  payoutList: {},
  deleteStatus: {},
  termDetail: {},
}

export default function payoutReducer(state = initialState, action) {
	 switch (action.type) {
	 	case payoutConstants.POST_PAYOUT_REQUEST:
	      return {
	        sending: true
	    };
	    case payoutConstants.POST_PAYOUT_SUCCESS:
	      return {
	        ...state,
	        payoutStatus: action.data,
	        sending: false
	    };
	    case payoutConstants.POST_PAYOUT_FAILURE:
	      return {
	        ...state,
	        error: action.error,
	        sending: false
	    };
	    case payoutConstants.GET_PAYOUTLIST_REQUEST:
	      return {
	        sending: true
	    };
	    case payoutConstants.GET_PAYOUTLIST_SUCCESS:
	      return {
	        ...state,
	        payoutList: action.data,
	        sending: false
	    };
	    case payoutConstants.GET_PAYOUTLIST_FAILURE:
	      return {
	        ...state,
	        error: action.error,
	        sending: false
	    };
	    case payoutConstants.DELETE_PAYOUT_REQUEST:
	      return {
	        sending: true
	    };
	    case payoutConstants.DELETE_PAYOUT_SUCCESS:
	      return {
	        ...state,
	        deleteStatus: action.data,
	        sending: false
	    };
	    case payoutConstants.DELETE_PAYOUT_FAILURE:
	      return {
	        ...state,
	        error: action.error,
	        sending: false
	    };
	    case payoutConstants.GET_PAYOUT_REQUEST:
	      return {
	        sending: true
	    };
	    case payoutConstants.GET_PAYOUT_SUCCESS:
	      return {
	        ...state,
	        termDetail: action.data,
	        sending: false
	    };
	    case payoutConstants.GET_PAYOUT_FAILURE:
	      return {
	        ...state,
	        error: action.error,
	        sending: false
	    };
	    default:
      		return state;
	 }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/payoutReducer.js